<div>
    <nav class="navbar navbar-expand-lg classic transparent navbar-light">
    <div class="container flex-lg-row flex-nowrap align-items-center nav-bar">
        <div
        class="navbar-collapse-wrapper bg-white d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center align-items-center-new">
        <div class="logo-wth-txt d-flex align-items-center gap-3 nav-logo">
            <!-- <img
            src="assets/img/mobile_autoverse_logo.svg"
            alt="Autoverse Logo"
            />
            <h2 class="m-0">AUTOVERSE</h2> -->
            <img
              [src]="garageData?.primaryLogo"
              alt="Garage Logo"
              class="navbar-garage-logo" (click)="goToGarageDetails()"
            />
        </div>
        <div class="d-lg-none me-2 qck-bkng" *ngIf="showQuickBookBtn" >
        <button
            class="btn btn-sm btn-outline-primary rounded-pill qck-bkng-btn"
            (click)="openRequestModal()">
            Quick Booking
        </button>
        </div>
        <button
                    class="navbar-toggler d-lg-none mat-hamburger-btn hambrgr"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target=".offcanvas-nav"
                    aria-label="Toggle navigation"
                    >
                    <mat-icon>menu</mat-icon>
                </button>
                
        </div>


        <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
        <div class="offcanvas-header d-lg-none">
            <h3 class="text-white fs-30 mb-0">Autoverse</h3>
            <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            ></button>
        </div>

        <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
            <ul class="navbar-nav align-items-center-abt">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                Service Details
                </a>
                <ul class="dropdown-menu">
                <li>
                    <a class="dropdown-item" (click)="scrollTo('whn-service-need')">
                    When is the service needed
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="scrollTo('wht-included')">
                    What is included
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="scrollTo('faq-sec')">
                    FAQs
                    </a>
                </li>
                </ul>
            </li>
            <a class="nav-link" (click)="scrollTo('indicate-price-sec')">Pricing</a>
            <a class="nav-link" (click)="scrollTo('how-it-wrks')">How It Works</a>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                Reviews
                </a>
                <ul class="dropdown-menu">
                <li>
                    <a class="dropdown-item" (click)="scrollTo('garage-facts')">
                   What customers say
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="scrollTo('makes')">
                    Car brands we serve
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="scrollTo('why-trust-us')">
                    Why Trust Us
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" (click)="scrollTo('contact-us')">
                    Contact us
                    </a>
                </li>
                </ul>
            </li>
            <li class="nav-item book" *ngIf="showRequestBtn">
                <button
                    class="btn btn-lg btn-outline-white rounded-pill rqstbtn"
                    (click)="onSidebarBookClick()">
                    Book Service
                </button>
            </li>
            </ul>
        </div>
        </div>
    </div>
    </nav>
</div>

<div class="services-main">
  <div class="first-hero-sec" id="hero-section" #heroSection>
      <section class="wrapper bg-light position-relative min-vh-70 d-lg-flex align-items-center">
          <!-- <div class="rounded-4-lg-start col-lg-6 order-lg-2 position-lg-absolute top-0 end-0 image-wrapper bg-image bg-cover h-100 min-vh-50" data-image-src="src\assets\img\herosectionimageservicedetailspage\Periodic Car Service - Hero.png">
          </div> -->
          <div class="rounded-4-lg-start col-lg-6 order-lg-2 position-lg-absolute top-0 end-0 image-wrapper bg-image bg-cover h-100  hero-img" style="top: auto;"><img src="../../../assets/img/herosectionimageservicedetailspage/Suspension.png"></div>
          <!--/column -->
          <div class="container">
          <div class="row">
              <div class="col-lg-6">
              <div class=" px-md-11 ps-lg-0 pe-lg-13 text-center text-lg-start"  data-group="page-title" data-delay="600">
                  <h1 class="display-1 mb-5">Suspension or Steering Issues? Enjoy a Smooth, Stable Drive</h1>
                  <p class="lead fs-25 lh-sm mb-7 pe-md-10"> Bumpy ride, unusual sounds, or loose steering? We diagnose the issue and restore driving comfort and control.</p>
                  <div class="d-flex justify-content-center justify-content-lg-start"  data-group="page-title-buttons" data-delay="900">
                  <!-- <span><a href="#" class="btn btn-lg btn-primary rounded-pill me-2">Book Suspension Check</a></span> -->
                  <span class="btn btn-lg btn-primary rounded-pill me-2 " (click)="openRequestModal()">Book Suspension Check</span>
                  </div>
              </div>
              <!--/div -->
              </div>
              <!--/column -->
          </div>
          <!--/.row -->
          </div>
          <!-- /.container -->
      </section>
  </div>


  <section class="wrapper bg-light" id="whn-service-need">
      <div class="container pt-10 pt-md-15 ">
      <div class="row">
          <div class="col-lg-8 col-xl-7 col-xxl-6">
          <h2 class="fs-16 text-uppercase text-line text-primary mb-3">When your ride feels rough or unstable</h2>
          <h3 class="display-4 mb-9">Suspension and steering issues affect comfort, handling, and overall driving safety.</h3>
          </div>
          <!-- /column -->
      </div>
      <!-- /.row -->
      <div class="row gx-md-8 gy-8 mb-14">
          <div class="col-md-6 col-lg-3">
          <div class="icon btn btn-block btn-lg btn-soft-primary pe-none mb-6 background-remove-img"> <img src="../../../assets/img/whenistheserviceneededimagesservicedetails/Suspension_1_When_Needed-removebg-preview.png" style="width: 100px;"> </div>
          <h4> Uncomfortable or Bumpy Ride</h4>
          <p class="mb-3">Car feels rough even on normal roads.</p>
          <!-- <a href="#" class="more hover link-primary">Learn More</a> -->
          </div>
          <div class="col-md-6 col-lg-3">
          <div class="icon btn btn-block btn-lg btn-soft-primary pe-none mb-6 background-remove-img"><img src="../../../assets/img/whenistheserviceneededimagesservicedetails/Suspension_2_When_Needed-removebg-preview.png" style="width: 100px;">  </div>
          <h4>Clunking or Knocking Sounds</h4>
          <p class="mb-3"> Noises when driving over bumps or uneven surfaces.</p>
          <!-- <a href="#" class="more hover link-primary">Learn More</a> -->
          </div>
          <div class="col-md-6 col-lg-3">
          <div class="icon btn btn-block btn-lg btn-soft-primary pe-none mb-6 background-remove-img"><img src="../../../assets/img/whenistheserviceneededimagesservicedetails/Suspension_3_When_Needed-removebg-preview.png" style="width: 100px;">  </div>
          <h4>Steering Feels Loose or Heavy</h4>
          <p class="mb-3">Steering does not feel stable or responsive.</p>
          <!-- <a href="#" class="more hover link-primary">Learn More</a> -->
          </div>
          <div class="col-md-6 col-lg-3">
          <div class="icon btn btn-block btn-lg btn-soft-primary pe-none mb-6 background-remove-img"> <img src="../../../assets/img/whenistheserviceneededimagesservicedetails/Suspension_4_When_Needed-removebg-preview.png" style="width: 100px;"> </div>
          <h4>Uneven Tyre Wear</h4>
          <p class="mb-3">Tyres wear out faster or unevenly.</p>
          <!-- <a href="#" class="more hover link-primary">Learn More</a> -->
          </div>
      </div>
      </div>
  </section>

  <section class="wrapper bg-light" id="wht-included">
    <div class="container text-center">
      <div class="row">
        <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2 class="fs-15 text-uppercase text-muted mb-3">What’s Included in Suspension & Steering Service</h2>
          <h3 class="display-4 mb-0 px-xl-10">Steering and suspension inspected and adjusted for smooth ride.</h3>
        </div>
        <!-- /column -->
      </div>
    </div>
  </section>

  <section class="wrapper bg-light">
    <div class="container pb-10">
      <!-- /.row -->
      <div class="row gx-md-8 gx-xl-12 gy-6 mt-8 bullet-text-div">
        <!-- /column -->
        <div class="col-lg-4">
          <ul class="icon-list bullet-bg bullet-soft-primary">
            <li><i class="uil uil-check"></i>Shock absorber inspection.</li>
            <li><i class="uil uil-check"></i>Steering joints & linkages check.</li>
            <li><i class="uil uil-check"></i>Wheel alignment check.</li>
            <li><i class="uil uil-check"></i>Road test after repairs.</li>
            <!-- <li><i class="uil uil-check"></i>Polishing and finishing.</li>
            <li><i class="uil uil-check"></i>Final quality inspection.</li> -->
          </ul>
        </div>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>

  <section class="wrapper bg-soft-primary" id="indicate-price-sec">
      <div class="container pt-14 pb-18 pt-md-17 pb-md-22 text-center">
          <div class="row">
              <div class="col-lg-10 col-xl-9 col-xxl-8 mx-auto">
                  <h3 class="display-4 mb-md-6 px-lg-10">Indicative pricing. Final price is shared after inspection and varies by car and its condition.</h3>
              </div>
              <!--/column -->
          </div>
          <!--/.row -->
      </div>
      <!-- /.container -->
  </section>
  <section class="wrapper bg-light">
      <div class="container py-14 py-md-16">
          <div class="pricing-wrapper position-relative mt-n22 mt-md-n24">
              <div class="shape bg-dot primary rellax w-16 h-18" data-rellax-speed="1" style="top: 2rem; right: -2.4rem;"></div>
              <div class="shape rounded-circle bg-line red rellax w-18 h-18 d-none d-lg-block" data-rellax-speed="1" style="bottom: 0.5rem; left: -2.5rem;"></div>
              <!-- <div class="pricing-switcher-wrapper switcher">
                  <p class="mb-0 pe-3">Monthly</p>
                  <div class="pricing-switchers">
                      <div class="pricing-switcher pricing-switcher-active"></div>
                      <div class="pricing-switcher"></div>
                      <div class="switcher-button bg-primary"></div>
                  </div>
                  <p class="mb-0 ps-3">Yearly</p>
              </div> -->
              <div class="row gy-6 mt-3 mt-md-5">
                  <div class="col-md-6 col-lg-4">
                      <div class="pricing card shadow-lg text-center">
                          <div class="card-body">
                              <!-- <img src="@@webRoot/assets/img/icons/lineal/shopping-basket.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3" alt="" /> -->
                              <div style="display: flex; align-items: center; justify-content: center;"> 
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 412.9" data-inject-url="https://sandbox.elemisthemes.com/assets/img/icons/lineal/shopping-basket.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3 "><path class="lineal-fill" d="M453.8 238.1l-9.6 76.3H67.8l-9.6-76.3z"></path><circle class="lineal-fill" cx="178.1" cy="149.9" r="35.1"></circle><circle class="lineal-fill" cx="333.9" cy="149.9" r="35.1"></circle><path class="lineal-stroke" d="M498.6 136.5h-60.2c-7.4-.2-13.6 5.7-13.8 13.1-.2 7.4 5.7 13.6 13.1 13.8h11.8l-7.5 61.3H70.1l-7.5-61.3h68.9c7.4 25.7 34.3 40.6 60 33.1 16-4.6 28.5-17.1 33.1-33.1h62.6c7.4 25.7 34.3 40.6 60 33.2 25.7-7.4 40.6-34.3 33.2-60-4.9-17.1-18.9-30.1-36.3-33.9l-39-94.2c-2.8-6.9-10.7-10.1-17.6-7.3s-10.1 10.7-7.3 17.6l35.7 86.2c-14 5.5-24.6 17.2-28.8 31.6h-62.6c-4.2-14.4-14.8-26.1-28.8-31.7l35.7-86.2c2.8-6.9-.4-14.7-7.3-17.6s-14.7.4-17.6 7.3l-39.1 94.2c-17.4 3.8-31.3 16.9-36.2 33.9H13.4C6 136.7.1 142.9.3 150.3c.2 7.1 5.9 12.9 13.1 13.1h22.1l29.8 237.8c.9 6.7 6.6 11.8 13.3 11.8h354.8c6.8 0 12.5-5 13.3-11.8l29.8-237.8h22c7.4-.2 13.3-6.4 13.1-13.8-.2-7.2-5.9-12.9-13-13.1zm-165-8.2c.4 0 .9.1 1.3.1h.7c11.9.9 20.8 11.3 19.9 23.2-.9 11.9-11.3 20.8-23.2 19.9-11.9-.9-20.8-11.3-19.9-23.2.8-11.1 10-19.7 21.2-20zm-157.1.1h.7c.4 0 .9-.1 1.3-.1 11.9.2 21.4 10 21.3 22-.2 11.9-10 21.4-22 21.3-11.9-.2-21.4-10-21.3-22 .2-11.2 8.9-20.4 20-21.2zm-103 123.1h365.1l-6.3 49.5H79.7l-6.2-49.5zM90.4 386L83 327.9h345.9l-7.4 58.1H90.4z"></path></svg>
                              </div>
                              <h4 class="card-title">Basic Check</h4>
                              <div class="prices text-dark">
                                  <div class="price price-show"><span class="price-value"> ₹799 – ₹1,499</span></div>
                                  <!-- <div class="price price-hide price-hidden"><span class="price-currency">$</span><span class="price-value">99</span> <span class="price-duration">yr</span></div> -->
                              </div>
                              <!--/.prices -->
                              <div style="align-items: center; text-align: center; justify-content: center; ">
                              <ul class="icon-list bullet-bg bullet-soft-primary mb-8 text-start">
                                  <li><i class="uil uil-check"></i><span><strong>Suspension inspection</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Steering play check</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Noise diagnosis</strong></span></li>
                              </ul>
                              <div class="btn btn-primary rounded choose-plan1">mild sounds</div>
                              </div>
                          </div>
                          <!--/.card-body -->
                      </div>
                      <!--/.pricing -->
                  </div>
                  <!--/column -->
                  <div class="col-md-6 col-lg-4">
                      <div class="pricing card shadow-lg text-center">
                          <div class="card-body">
                              <!-- <img src="@@webRoot/assets/img/icons/lineal/shopping-basket.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3" alt="" /> -->
                              <div style="display: flex; align-items: center; justify-content: center;"> 
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 479.8 512" data-inject-url="https://sandbox.elemisthemes.com/assets/img/icons/lineal/home.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3"><path class="lineal-stroke" d="M308 512H61.9c-8 0-14.4-6.5-14.4-14.4V227.2c0-4.3 2-8.4 5.4-11.2l178-143.7c5.3-4.3 12.8-4.3 18.1 0L427 216c3.4 2.7 5.4 6.9 5.4 11.2v269.6c-.2 8-6.8 14.3-14.8 14-7.7-.2-13.8-6.4-14-14V234.1L239.9 102 76.3 234.1v249.1H308c8 .2 14.3 6.8 14 14.8-.2 7.6-6.3 13.8-14 14z"></path><path class="lineal-stroke" d="M465.4 209.8c-3.3 0-6.4-1.1-9-3.2L239.9 32.9 23.5 206.7c-6.2 5-15.3 4-20.3-2.2s-4-15.3 2.2-20.3l225.5-181c5.3-4.2 12.8-4.2 18.1 0l225.5 181c6.2 5 7.2 14.1 2.2 20.3-2.8 3.3-6.9 5.3-11.3 5.3z"></path><ellipse transform="rotate(-80.781 239.904 207.686)" class="lineal-fill" cx="239.9" cy="207.7" rx="42.9" ry="43"></ellipse><path class="lineal-stroke" d="M239.9 265.1c-31.7 0-57.4-25.7-57.4-57.4s25.7-57.4 57.4-57.4 57.4 25.7 57.4 57.4c-.1 31.7-25.7 57.3-57.4 57.4zm0-85.9c-15.8 0-28.5 12.8-28.5 28.5s12.8 28.5 28.5 28.5 28.5-12.8 28.5-28.5c0-15.8-12.8-28.5-28.5-28.5z"></path><path class="lineal-fill" d="M171.8 325.7h136.1v171.9H171.8z"></path><path class="lineal-stroke" d="M308 512H171.8c-8 0-14.4-6.5-14.4-14.4V325.7c0-8 6.5-14.4 14.4-14.4H308c8 0 14.4 6.5 14.4 14.4v171.9c0 7.9-6.4 14.4-14.4 14.4zm-121.8-28.9h107.3v-143H186.2v143zm234.2-317.7c-7.9 0-14.4-6.5-14.4-14.4V73.3h-28.6c-8 0-14.4-6.5-14.4-14.4s6.5-14.4 14.4-14.4h43c8 0 14.4 6.5 14.4 14.4v92c0 8-6.4 14.4-14.4 14.5 0-.1 0 0 0 0z"></path></svg> 
                              </div>
                              <h4 class="card-title">Standard Repair</h4>
                              <div class="prices text-dark">
                                  <div class="price price-show"><span class="price-value">₹5,000 – ₹10,000</span></div>
                                  <!-- <div class="price price-hide price-hidden"><span class="price-currency">$</span><span class="price-value">99</span> <span class="price-duration">yr</span></div> -->
                              </div>
                              <!--/.prices -->
                              <div style="align-items: center; text-align: center; justify-content: center; ">
                              <ul class="icon-list bullet-bg bullet-soft-primary mb-8 text-start">
                                  <li><i class="uil uil-check"></i><span><strong>Shock absorber replacement</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Bushes / link rods</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Wheel alignment</strong></span></li>
                              </ul>
                              <div class="btn btn-primary rounded choose-plan2">bumpy ride</div>
                              </div>
                          </div>
                          <!--/.card-body -->
                      </div>
                      <!--/.pricing -->
                  </div>
                  <!--/column -->
                  <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-0">
                      <div class="pricing card shadow-lg text-center">
                          <div class="card-body">
                              <!-- <img src="@@webRoot/assets/img/icons/lineal/shopping-basket.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3" alt="" /> -->
                              <div style="display: flex; align-items: center; justify-content: center;"> 
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 409.6 380.8" data-inject-url="https://sandbox.elemisthemes.com/assets/img/icons/lineal/briefcase-2.svg" class="svg-inject icon-svg icon-svg-md text-primary mb-3"><path class="lineal-stroke" d="M299.9 104.7h-23.8V56.5c0-18.1-14.6-32.7-32.7-32.7h-77.2c-18 0-32.7 14.7-32.7 32.7v48.2h-23.8V56.5C109.8 25.3 135 0 166.2 0h77.2c31.2 0 56.4 25.3 56.5 56.5v48.2z"></path><path class="lineal-stroke" d="M360.5 380.8H49.1c-27.1 0-49-22-49.1-49.1V119.1C0 92 22 70 49.1 70h311.5c27.1 0 49 22 49.1 49.1v212.7c-.1 27.1-22.1 49-49.2 49zM49.1 93.8c-14 0-25.3 11.3-25.3 25.3v212.7c0 14 11.3 25.3 25.3 25.3h311.5c14 0 25.3-11.3 25.3-25.3V119.1c0-14-11.3-25.3-25.3-25.3H49.1z"></path><path class="lineal-fill" d="M49.2 81.7c-18.4 0-33.3 14.8-33.3 33.2 0 2.7.3 5.3.9 7.9C35.4 197.9 103.6 254 184.2 254h41.2c80.6 0 148.8-56.1 167.3-131.2 4.3-17.8-6.6-35.8-24.5-40.2-2.6-.6-5.2-.9-7.9-.9H49.2z"></path><path class="lineal-stroke" d="M225.4 265.9h-41.2c-41.5-.1-81.8-14.2-114.3-40C38 200.5 15.3 165.2 5.4 125.6-.5 101.4 14.3 77 38.6 71.1c3.5-.9 7.1-1.3 10.7-1.3h311.1c24.9 0 45.2 20.2 45.2 45.1 0 3.6-.4 7.2-1.3 10.7-9.9 39.6-32.6 74.8-64.5 100.2-32.6 25.9-72.9 40-114.4 40.1zM49.2 93.6c-6.6 0-12.9 3-16.9 8.2-4.1 5.1-5.5 11.8-3.9 18.2 17.6 71.8 81.9 122.3 155.8 122.2h41.2c73.9.1 138.3-50.4 155.8-122.2 1.6-6.3.1-13-3.9-18.1-4.1-5.2-10.3-8.3-16.9-8.2l-311.2-.1z"></path><path class="lineal-fill" d="M128.5 288.5h-13.8c-8.9 0-16.1-7.2-16.1-16.1v-48.3c0-8.9 7.2-16.1 16.1-16.1h13.8c8.9 0 16.1 7.2 16.1 16.1v48.3c0 8.9-7.2 16.1-16.1 16.1z"></path><path class="lineal-stroke" d="M128.5 300.4h-13.8c-15.5 0-28-12.5-28-28v-48.3c0-15.5 12.5-28 28-28h13.8c15.5 0 28 12.5 28 28v48.3c0 15.5-12.5 28-28 28zm-13.8-80.5c-2.3 0-4.2 1.9-4.2 4.2v48.3c0 2.3 1.9 4.2 4.2 4.2h13.8c2.3 0 4.2-1.9 4.2-4.2v-48.3c0-2.3-1.9-4.2-4.2-4.2h-13.8z"></path><path class="lineal-fill" d="M294.9 288.5h-13.8c-8.9 0-16.1-7.2-16.1-16.1v-48.3c0-8.9 7.2-16.1 16.1-16.1h13.8c8.9 0 16.1 7.2 16.1 16.1v48.3c0 8.9-7.2 16.1-16.1 16.1z"></path><path class="lineal-stroke" d="M294.9 300.4h-13.8c-15.5 0-28-12.5-28-28v-48.3c0-15.5 12.5-28 28-28h13.8c15.5 0 28 12.5 28 28v48.3c0 15.5-12.5 28-28 28zm-13.8-80.5c-2.3 0-4.2 1.9-4.2 4.2v48.3c0 2.3 1.9 4.2 4.2 4.2h13.8c2.3 0 4.2-1.9 4.2-4.2v-48.3c0-2.3-1.9-4.2-4.2-4.2h-13.8z"></path></svg>
                              </div>
                              <h4 class="card-title">Major Repair </h4>
                              <div class="prices text-dark">
                                  <div class="price price-show"><span class="price-value">₹15,000 – ₹30,000</span></div>
                                  <!-- <div class="price price-hide price-hidden"><span class="price-currency">$</span><span class="price-value">99</span> <span class="price-duration">yr</span></div> -->
                              </div>
                              <!--/.prices -->
                              <div style="align-items: center; text-align: center; justify-content: center; ">
                              <ul class="icon-list bullet-bg bullet-soft-primary mb-8 text-start">
                                  <li><i class="uil uil-check"></i><span><strong>Full suspension overhaul</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Steering rack repair</strong></span></li>
                                  <li><i class="uil uil-check"></i><span><strong>Handling correction</strong></span></li>
                              </ul>
                              <div class="btn btn-primary rounded choose-plan3">poor control, heavy vibration</div>
                              </div>
                          </div>
                          <!--/.card-body -->
                      </div>
                      <!--/.pricing -->
                  </div>
                  <!--/column -->
              </div>
              <!--/.row -->
          </div>
          <!--/.pricing-wrapper -->
      </div>
      <!-- /.container -->
  </section>

  <section class="wrapper" id="how-it-wrks">
    <div class="container py-14 py-md-16">
      <div class="row text-center">
        <div class="col-md-10 col-lg-7 mx-auto position-relative">
          <img src="./assets/img/svg/doodle5.svg" class="w-15 position-absolute d-none d-lg-block" data-delay="1800" style="bottom: -60%; right: 10%" alt="">
          <img src="./assets/img/svg/doodle6.svg" class="h-15 position-absolute d-none d-lg-block" data-delay="1800" style="top: -40%; left: -5%" alt="">
          <h2 class="fs-16 text-uppercase text-muted mb-3">HOW IT WORKS</h2>
          <h3 class="display-3 mb-8 px-xl-6" style=" font-style: normal;">Not Sure What Your Car Needs? <span class="text-gradient gradient-7">We’ll Help </span> You Understand.</h3>
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="col-xxl-11 mx-auto">
          <div class="row gy-10 gy-lg-0 text-center d-flex align-items-center">
            <div class="col-md-6 col-lg-4 mx-auto mb-n10 mb-lg-0">
              <figure class="mx-auto"><img src="../../../assets/img/how-it-works/how-it-works.png" srcset="../../../assets/img/how-it-works/how-it-works.png 2x" alt=""></figure>
            </div>
            <!-- /column -->
            <div class="w-100 d-lg-none"></div>
            <div class="col-md-6 col-lg-4 order-lg-first">
              <div class="mb-8">
                <span class="fs-60 lh-1 mb-3 fw-normal text-gradient gradient-7">01</span>
                <h4 class="fs-20">Tell Us the Problem</h4>
                <p class="mb-0 px-xl-7">Noise, warning light, or something feels off? Just tell us what you’re experiencing.</p>
              </div>
              <!-- /div -->
              <div>
                <span class="fs-60 lh-1 mb-3 fw-normal text-gradient gradient-7">02</span>
                <h4 class="fs-20">We Inspect & Explain</h4>
                <p class="mb-0 px-xl-7">Our experts check your car properly and explain the issue in simple, clear language.</p>
              </div>
              <!-- /div -->
            </div>
            <!-- /column -->
            <div class="col-md-6 col-lg-4">
              <div class="mb-8">
                <span class="fs-60 lh-1 mb-3 fw-normal text-gradient gradient-7">03</span>
                <h4 class="fs-20">You Approve the Cost</h4>
                <p class="mb-0 px-xl-7">We share the price upfront.Work starts only after your approval — no hidden charges.</p>
              </div>
              <!-- /div -->
              <div>
                <span class="fs-60 lh-1 mb-3 fw-normal text-gradient gradient-7">04</span>
                <h4 class="fs-20">We Fix It With Care</h4>
                <p class="mb-0 px-xl-7">Your car is serviced or repaired using genuine parts and returned on time, ready to drive.</p>
              </div>
              <!-- /div -->
            </div>
            <!-- /column -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>

  <div id="faq-sec">
      <section class="wrapper bg-soft-primary">
          <div class="container py-14 pt-md-16 pb-md-16">
              <div class="row">
                  <div class="col-xl-10 mx-auto faqs-main">
                      <!-- <div class="mt-lg-n20 mt-xl-n22 mb-14 mb-md-16 position-relative" data-cue="slideInUp">
                          <a href="@@webRoot/assets/media/movie.mp4" class="btn btn-circle btn-primary btn-play ripple mx-auto mb-5 position-absolute" style="top:50%; left: 50%; transform: translate(-50%,-50%); z-index:3;" data-glightbox><i class="icn-caret-right"></i></a>
                          <figure class="rounded shadow"><img src="@@webRoot/assets/img/photos/v1.jpg" srcset="@@webRoot/assets/img/photos/v1@2x.jpg 2x" alt=""></figure>
                      </div> -->
                      <h2 class="fs-15 text-uppercase text-muted mb-3 text-center">Frequently Asked Questions</h2>
                      <h3 class="display-4 mb-10 px-lg-12 px-xl-15 text-center">Answers to common queries about our car services, maintenance, and repairs.</h3>
                      <div class="row">
                          <div class="col-lg-6 mb-0">
                              <div id="accordion-1" class="accordion-wrapper">
                                  <div class="card accordion-item">
                                      <div class="card-header" id="accordion-heading-1-1">
                                          <button class="collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-1-1" aria-expanded="false" aria-controls="accordion-collapse-1-1"> How do I know if my suspension needs service?</button>
                                      </div>
                                      <!-- /.card-header -->
                                      <div id="accordion-collapse-1-1" class="collapse" aria-labelledby="accordion-heading-1-1" data-bs-target="#accordion-1">
                                          <div class="card-body">
                                              <p>Look out for bumpy rides, unusual sounds, or loose steering.</p>
                                          </div>
                                          <!-- /.card-body -->
                                      </div>
                                      <!-- /.collapse -->
                                  </div>
                                  <!-- /.card -->
                                  <div class="card accordion-item">
                                      <div class="card-header" id="accordion-heading-1-2">
                                          <button class="collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-1-2" aria-expanded="false" aria-controls="accordion-collapse-1-2">Can suspension problems affect safety?</button>
                                      </div>
                                      <!-- /.card-header -->
                                      <div id="accordion-collapse-1-2" class="collapse" aria-labelledby="accordion-heading-1-2" data-bs-target="#accordion-1">
                                          <div class="card-body">
                                              <p>Yes, faulty suspension or steering can impact handling and comfort.</p>
                                          </div>
                                          <!-- /.card-body -->
                                      </div>
                                      <!-- /.collapse -->
                                  </div>
                                  <!-- /.card -->
                              </div>
                              <!-- /.accordion-wrapper -->
                          </div>
                          <!--/column -->
                          <div class="col-lg-6">
                              <div id="accordion-2" class="accordion-wrapper">
                                  <!-- /.card -->
                                  <div class="card accordion-item">
                                      <div class="card-header" id="accordion-heading-2-2">
                                          <button class="collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-2-2" aria-expanded="false" aria-controls="accordion-collapse-2-2"> What’s included in the service?</button>
                                      </div>
                                      <!-- /.card-header -->
                                      <div id="accordion-collapse-2-2" class="collapse" aria-labelledby="accordion-heading-2-2" data-bs-target="#accordion-2">
                                          <div class="card-body">
                                              <p>Full inspection, adjustments, and repairs to steering and suspension components.</p>
                                          </div>
                                          <!-- /.card-body -->
                                      </div>
                                      <!-- /.collapse -->
                                  </div>
                                  <!-- /.card -->
                                  <div class="card accordion-item">
                                      <div class="card-header" id="accordion-heading-2-3">
                                          <button class="collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-collapse-2-3" aria-expanded="false" aria-controls="accordion-collapse-2-3"> How long will it take to fix suspension or steering issues?</button>
                                      </div>
                                      <!-- /.card-header -->
                                      <div id="accordion-collapse-2-3" class="collapse" aria-labelledby="accordion-heading-2-3" data-bs-target="#accordion-2">
                                          <div class="card-body">
                                              <p> Typically 2–4 hours depending on the condition of your car.</p>
                                          </div>
                                          <!-- /.card-body -->
                                      </div>
                                      <!-- /.collapse -->
                                  </div>
                                  <!-- /.card -->
                              </div>
                              <!-- /.accordion-wrapper -->
                          </div>
                          <!--/column -->
                      </div>
                      <!--/.row -->
                  </div>
                  <!--/column -->
              </div>
              <!--/.row -->
          </div>
          <!-- /.container -->
      </section>
  </div>

  <section class="wrapper bg-light bg-soft-primary"  id="why-trust-us">
    <div class="container">
      <!--/.row -->
      <div class="row text-center">
        <div class="col-lg-9 mx-auto">
          <h3 class="display-4 mb-0 text-center px-xl-10 px-xxl-15">Why trust {{ garageData.garageShortName }} with your car. We take care of your car like it’s our own</h3>
          <div class="row gx-lg-8 gx-xl-12 process-wrapper text-center mt-10">
            <div class="col-md-4"> <img src="../../../assets/img/how-it-works/why_trust_garage_1.png" class=" icon-svg icon-svg-md text-primary mb-3 why-trust-icon" alt="" />
              <h4 class="mb-1">1. Genuine OEM & OES Parts</h4>
              <p class="mb-0">Parts made for your car, ensuring performance and reliability.</p>
            </div>
            <!--/column -->
            <div class="col-md-4"> <img src="../../../assets/img/how-it-works/why_trust_garage_2.png" class=" icon-svg icon-svg-md text-red mb-3 why-trust-icon" alt="" />
              <h4 class="mb-1">2. Skilled & Experienced Technicians</h4>
              <p class="mb-0">Handled by trained experts, giving you peace of mind.</p>
            </div>
            <!--/column -->
            <div class="col-md-4"> <img src="../../../assets/img/how-it-works/why_trust_garage_3.png" class=" icon-svg icon-svg-md text-leaf mb-3 why-trust-icon" alt="" />
              <h4 class="mb-1">3. Transparent Pricing & Full Control</h4>
              <p class="mb-0">Clear estimates before work starts — no surprises, no hidden costs.</p>
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>

  <section class="wrapper bg-soft-primary"  id="garage-facts">
    <div class="container py-14 pt-md-17 pb-md-21">
      <div class="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0 mb-2 align-items-end">
        <div class="col-lg-4">
          <h2 class="fs-16 text-uppercase text-line text-primary mb-3">GARAGE FACTS</h2>
          <h3 class="display-4 mb-0 pe-xxl-15">We are proud of our works</h3>
        </div>
        <!-- /column -->
        <div class="col-lg-8 mt-lg-2">
          <div class="row align-items-center counter-wrapper gy-6 text-center">
            <div class="col-md-4">
              <div class="count-main" >
                <h3 class="counter counter-lg">5000</h3>
                <div class="count-mat-icon"><mat-icon class="mat">add</mat-icon></div>
              </div>
              <p>Car Serviced</p>
            </div>
            <!--/column -->
            <div class="col-md-4">
              <div class="count-main" >
                <h3 class="counter counter-lg">10</h3>
                <div class="count-mat-icon"><mat-icon class="mat">add</mat-icon></div>
              </div>
              <p>Year Experience</p>
            </div>
            <!--/column -->
            <div class="col-md-4" id="customer-review">
              <div class="count-main" >
                <h3 class="counter counter-lg">80</h3>
                <div class="count-mat-icon" style="    font-size: 24px; width: auto;   height: auto; padding: 0px 5px;">%</div>
              </div>
              <p>Same Day Service</p>
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->

<!-- /section -->
 <div>
  <section class="wrapper bg-light angled upper-end lower-start">
    <div class="container py-16 py-md-18 position-relative" style="padding-bottom: 0 !important;">
      <div class="position-relative mt-n18 mt-n23">
        <div class="shape rounded-circle bg-line primary rellax w-18 h-18" data-rellax-speed="1" style="top: -2rem; right: -2.7rem; z-index:0;"></div>
        <div class="shape rounded-circle bg-soft-primary rellax w-18 h-18" data-rellax-speed="1" style="bottom: -1rem; left: -3rem; z-index:0;"></div>
        <div class="card shadow-lg image-down">
          <div class="row gx-0">
            <div class="col-lg-6 image-wrapper bg-image bg-cover rounded-top rounded-lg-start"><img src="../../../assets/img/specificgaragewebpageimages/Garage Customer Testimonial.png">
            </div>
            <!--/column -->
            <div class="col-lg-6">
              <div class="">
                <div class="swiper-container dots-closer mb-4" data-margin="30" data-dots="true">
                  <div class="swiper testimonial-swiper" style="height: fit-content;">
                    <div class="swiper-wrapper" style="height: auto;">
                      <div
                        class="swiper-slide garage-testimonial"
                        *ngFor="let review of garageData?.reviews"
                        style="height: fit-content !important;"
                      >
                        <blockquote class="icon icon-top fs-lg text-center">
                          <p class="garage-review">“{{ review.testimonial }}”</p>

                          <div class="blockquote-details justify-content-center text-center">
                            <div class="info ps-0">
                              <h5 class="mb-1">{{ review.name }}</h5>
                              <p class="mb-0">Car Owner</p>
                            </div>
                          </div>
                        </blockquote>
                      </div>
                    </div>
                    <button class="swiper-button-prev-new"><mat-icon>arrow_back</mat-icon></button>
                    <!-- /.swiper-wrapper -->
                  </div>
                  <div class="swiper-pagination swiper-pagination-testimonial" style="bottom: 0;"></div>
                  <button class="swiper-button-next-new"><mat-icon>arrow_forward</mat-icon></button>
                  <!-- /.swiper -->
                </div>
                <!-- /.swiper-container -->
              </div>
              <!--/div -->
            </div>
            <!--/column -->
          </div>
          <!--/.row -->
        </div>
        <!-- /.card -->
      </div>
      <!--/.row -->
    </div>
    <!-- /.container -->
  </section>
</div>
  <!-- /section -->

<!-- Makes -->
<div>
  <section id="makes" class="wrapper bg-light">
    <div class="container" style="padding-top: 80px;">
      <div class="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0">
        <div class="col-lg-4 mt-lg-2">
          <h2 class="fs-15 text-uppercase text-muted mb-3">Cars we work on</h2>
          <h3 class="display-4 mb-3 pe-xxl-5">We service the most popular car brands on Indian roads.</h3>
          <p class="lead fs-lg mb-0 pe-xxl-5">If your car brand is not listed, call us — we’ll be happy to help.</p>
        </div>
        <div class="col-lg-8 position-relative d-flex align-items-center">
          <!-- Swiper Container -->
          <div class="swiper makes-swiper-container">
          <div class="swiper-wrapper">

            <!-- PAGE 1 -->
            <div class="swiper-slide">
              <div class="makes-grid">
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/marutisuzuki.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/hyundai.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/toyota.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/tata.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/honda.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/ford.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/volkswagen.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/mahindra.png"></div>
              </div>
            </div>

            <!-- PAGE 2 -->
            <div class="swiper-slide">
              <div class="makes-grid">
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/renault.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/skoda.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/chevrolet.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/fiat.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/nissan.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/audi.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/mercedesbenz.png"></div>
                <div class="make-logo"><img src="https://cube.getpitstop.com/assets/img/kia.png"></div>
              </div>
            </div>

          </div>
            <button class="swiper-button-prev-makes">
              <mat-icon class="arw-bck">arrow_back</mat-icon>
            </button>
            <button class="swiper-button-next-makes">
              <mat-icon class="arw-bck">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
  <div class="map-main-div" id="contact-us">
    <section class="wrapper bg-light angled upper-end" *ngIf="garageData">
      <div class="container">
        <div class="row mb-14 mb-md-16">
          <div class="col-xl-10 mx-auto">
            <div class="card">
              <div class="row gx-0">
                
                <!-- Map -->
                <div class="col-lg-6 align-self-stretch">
                  <div class="map map-full rounded-top rounded-lg-start">
                    <div class="map map-full rounded-top rounded-lg-start" style="height: 400px;">
                      
                      <google-map 
                        height="400px"
                        width="100%"
                        [center]="center"
                        [zoom]="14" [options]="mapOptions">

                        <map-marker
                          #markerElem="mapMarker"
                          [position]="marker.position"
                          [title]="marker.title"
                          [options]="marker.options"
                          (mapClick)="openInfo(markerElem)">
                          
                          <map-info-window>
                            <div>
                              <div style="display:flex; justify-content: space-between; align-items: center;">
                                <h2 class="small-map-header">{{ marker.title }}</h2>
                                <a [href]="directionsLink" target="_blank">
                                  <img src="./assets/img/direction_images-removebg-preview.png"
                                      style="width:30px;height:30px; margin-left:10px;">
                                </a>
                              </div>

                              <p class="small-map-p">{{ marker.address }}</p>

                              <div style="display:flex; align-items:center;">
                                <strong style="margin-right:5px;">{{ marker.googleRatings }}</strong>
                                <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                                  <mat-icon *ngIf="star === 'full'" style="color: gold; margin-right: 2px;">star</mat-icon>
                                  <mat-icon *ngIf="star === 'half'" style="color: gold; margin-right: 2px;">star_half</mat-icon>
                                </ng-container>
                                <span style="margin-left: 5px; color:#3f78e0;">
                                  {{ marker.googleReviewNumbers }} reviews
                                </span>
                              </div>

                              <!-- <a [href]="largerMapLink" target="_blank" style="color:#3f78e0;">View larger map</a> -->
                            </div>
                          </map-info-window>
                        </map-marker>
                      </google-map>
                      
                    </div>
                  </div>
                </div>

                <!-- Details -->
                <div class="col-lg-6">
                  <div class="p-md-11 p-lg-14 padding-div">
                    
                    <!-- Address -->
                    <div class="d-flex flex-row mb-3">
                      <div>
                        <div class="icon text-primary fs-28 me-4 mt-n1"> 
                          <i class="uil uil-location-pin-alt" style="color:dodgerblue;"></i>
                        </div>
                      </div>
                      <div>
                        <h5 class="mb-1">Address</h5>
                        <address>{{ garageData.address }}</address>
                      </div>
                    </div>

                    <!-- Ratings -->
                    <div class="d-flex flex-row mb-3">
                      <div>
                        <img src="./assets/img/googleicon.png" alt="Google" style="width:28px; height:28px !important; margin-right:16px;">
                      </div>
                      <div>
                        <h5 class="mb-1">Ratings / Reviews</h5>
                        <div class="div_ratings">
                          <span>{{ garageData.googleRatings }}</span>
                          <div class="div_new_rating">
                            <ng-container *ngFor="let star of getStars(garageData.googleRatings)">
                              <mat-icon *ngIf="star === 'full'">star</mat-icon>
                              <mat-icon *ngIf="star === 'half'">star_half</mat-icon>
                            </ng-container>
                          </div>
                          
                        </div>
                        <p>from {{ garageData.googleReviewNumbers }} Google reviews</p>
                      </div>
                    </div>

                    <div class="d-flex flex-row mb-3">
                      <div>
                        <div class="icon text-primary fs-28 me-4 mt-n1"> 
                          <!-- <i></i> -->
                          <div style="font-size: 20px;">🕘</div>
                        </div>
                      </div>
                      <div>
                        <h5 class="mb-1">Working Hours</h5>
                        <div>Mon-Sat : {{ garageData?.workingHours }}</div>
                        Sunday : Closed
                      </div>
                    </div>
                    <!-- Overlay -->
                    <div     class="popup-overlay"   [class.active]="isModalOpen"     (click)="closeModal()">  </div>
                    <!-- main popup -->
                    <!-- <div class="popup-container" [class.active]="isModalOpen">
                      <div class="popup-content">

                        <div class="popup-header">
                          <h3 class="fw-bold m-0">
                            <div class="call-icon-and-text">
                              <img src="./assets/img/call-image.png">
                              <div> Request a Call Back </div>
                              <button type="button" class="btn-close" (click)="closeModal()"></button>
                            </div>
                          </h3>
                        </div>

                        <p class="text-muted mb-4">
                          Leave your details and (optionally) pick a coupon.
                        </p>

                        <form [formGroup]="callbackForm" (ngSubmit)="submitForm()">
                          <input type="text" formControlName="name" class="form-control mb-2 p-2" placeholder="Name*" required>
                          <div class="text-danger small"
                            *ngIf="callbackForm.get('name')?.touched && callbackForm.get('name')?.hasError('required')">
                            Name is required
                          </div>

                          <input type="text" formControlName="mobile" class="form-control mb-2 p-2" placeholder="Mobile Number*" maxlength="10" required>
                          <div class="text-danger small" *ngIf="callbackForm.get('mobile')?.touched">
                            <span *ngIf="callbackForm.get('mobile')?.hasError('required')">Mobile number is required</span>
                            <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">Enter a valid 10-digit mobile number</span>
                          </div>

                          <input type="text" formControlName="issue" class="form-control mb-2 p-2" placeholder="Describe Your Issue (Optional)">

                          <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                            <div *ngFor="let c of coupons" 
                                class="coupon-card-option"
                                [class.active]="selectedCoupon?.couponId === c.couponId"
                                (click)="applyCoupon(c)">
                              <h5 class="fw-bold mb-1">{{ c.couponCode }} - {{ c.discount }}%</h5>
                              <p class="small m-0 text-muted">{{ c.description }}</p>
                            </div>
                          </div>

                          <button type="submit" class="btn btn-primary w-100" style="background:#144579;">Submit Details</button>
                        </form>
                      </div>
                    </div> -->
                    <div class="popup-container" [class.active]="isModalOpen">
                  <div class="popup-content">

                    <!-- Header -->
                    <div class="popup-header">
                      <h3 class="fw-bold m-0">
                        <div class="call-icon-and-text d-flex align-items-center gap-2">
                          <!-- Updated icon -->
                          <!-- <img src="./assets/img/appointment-icon.png" alt="appointment" /> -->
                          <mat-icon>bookmark_border</mat-icon>
                          <!-- Updated title -->
                          <div>Book an Appointment</div>

                          <button type="button" class="btn-close ms-auto" (click)="closeModal()"></button>
                        </div>
                      </h3>
                    </div>

                    <!-- Updated subheading -->
                    <p class="text-muted mb-4">
                      Quick and easy appointment booking.
                    </p>

                    <!-- Form -->
                    <form [formGroup]="callbackForm" (ngSubmit)="submitForm()">

                      <!-- Name -->
                      <input
                        type="text"
                        formControlName="name"
                        class="form-control mb-2 p-2"
                        placeholder="Name*" />
                      <div
                        class="text-danger small"
                        *ngIf="callbackForm.get('name')?.touched && callbackForm.get('name')?.hasError('required')">
                        Name is required
                      </div>

                      <!-- Mobile -->
                      <input
                        type="text"
                        formControlName="mobile"
                        class="form-control mb-2 p-2"
                        placeholder="Mobile Number*"
                        maxlength="10" />
                      <div class="text-danger small" *ngIf="callbackForm.get('mobile')?.touched">
                        <span *ngIf="callbackForm.get('mobile')?.hasError('required')">
                          Mobile number is required
                        </span>
                        <span *ngIf="callbackForm.get('mobile')?.hasError('pattern')">
                          Enter a valid 10-digit mobile number
                        </span>
                      </div>

                      <!-- Car Registration Number (NEW) -->
                      <input
                        type="text"
                        formControlName="registrationNumber"
                        class="form-control mb-2 p-2"
                        placeholder="Car Registration Number*"
                        (input)="callbackForm.get('registrationNumber')?.setValue($event.target.value.toUpperCase(), { emitEvent: false })" />
                        <div
                          class="text-danger small"
                          *ngIf="callbackForm.get('registrationNumber')?.touched">

                          <span *ngIf="callbackForm.get('registrationNumber')?.hasError('required')">
                            Car registration number is required
                          </span>

                          <span *ngIf="callbackForm.get('registrationNumber')?.hasError('pattern')">
                            Enter valid format (e.g. KA03AB1234)
                          </span>

                        </div>

                      <!-- Issue Dropdown (ONLY on Home Page) -->
                      <select
                        *ngIf="showIssueDropdown"
                        formControlName="issue"
                        class="form-control mb-3 p-2">

                        <option value="" disabled selected>Select the issue</option>

                        <option
                          *ngFor="let service of services"
                          [value]="service.key">
                          {{ service.label }}
                        </option>

                      </select>
                      <!-- Coupons Section (UNCHANGED & KEPT) -->
                      <div *ngIf="coupons.length > 0" class="coupon-options mb-4">
                        <div
                          *ngFor="let c of coupons"
                          class="coupon-card-option"
                          [class.active]="selectedCoupon?.couponId === c.couponId"
                          (click)="applyCoupon(c)">
                          <h5 class="fw-bold mb-1">
                            {{ c.couponCode }} - {{ c.discount }}%
                          </h5>
                          <p class="small m-0 text-muted">
                            {{ c.description }}
                          </p>
                        </div>
                      </div>

                      <!-- CTA -->
                      <button
                        type="submit"
                        class="btn btn-primary w-100"
                        style="background:#144579;">
                        Book an Appointment
                      </button>

                    </form>
                  </div>
                </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <section class="wrapper gradient-8 bg-lines" id="contact-us">
    <div class="container py-15 py-md-17 text-center">
      <div class="row">
        <div class="col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center">
          <h2 class="fs-16 text-uppercase text-white mb-3">TRUSTED BY CAR OWNERS</h2>
          <h3 class="display-3 text-white mb-6">We are
          <span class="underline-2 underline-gradient-6"><em>trusted</em></span> by over 5,000+ car owners.Book your appointment with confidence.</h3>
          <!-- <a href="#" class="btn btn-white">Join Us</a> -->
          <div class="button_div">
            <button class="requestBtn-new" (click)="openRequestModal()">
              Book an Appointment
            </button>
          </div>
        </div>
        <!-- /column -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </section>
  <!-- /section -->
  <!-- Coupon Section -->
  <div class="coupon-section" *ngIf="coupons && coupons.length > 0">
    <h2>💰 Exclusive Offers Just for You</h2>
    <div class="coupon-row">
      <div *ngFor="let coupon of coupons" class="coupon-card">
        <div class="coupon-title">{{ decodeEntities(coupon.title) }}</div>
        <h3 style="color:#144579">{{ coupon.discount }}% OFF</h3>
        <div class="coupon-subtitle">{{ decodeEntities(coupon.subTitle) }}</div>
        <div class="coupon-code">{{ coupon.couponCode }}</div>
        <button class="redeem-btn" (click)="openModal(coupon)">Redeem Now</button>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <!-- Coupon Modal -->
  <div class="modal-coupon" *ngIf="selectedCoupon">
    <div class="modal-content-coupon">

      <!-- Hot Deal Tag -->
      <span class="hot-deal-tag">{{ decodeEntities(selectedCoupon.tagDeal || '🔥 HOT DEAL') }}</span>

      <!-- Close Button -->
      <div class="modal-header-container">
        <div class="modal-header">🎉 Redeem Your Offer</div>
        <span class="close-btn" (click)="closeModal()">&times;</span>
        
      </div>
      <div class="underline"></div>

      <!-- Content -->
      <div class="pop-up-parent-div">
        <div class="modal-subtitle">{{ decodeEntities(selectedCoupon.subTitle) }}</div>
        <div class="valid-date-coupon-code">{{ selectedCoupon.couponCode }}</div>
        <div class="valid-date">Valid till: {{ selectedCoupon.validTill | date:'dd-MMM-yyyy' }}</div>
        <div class="description">{{ decodeEntities(selectedCoupon.description) }}</div>
      </div>

      <!-- Form Inputs -->
      <form [formGroup]="couponForm" (ngSubmit)="applyCouponForm()">
        <input type="text" formControlName="couponName" placeholder="Name*" required class="form-control mb-2 p-2">
          <input type="text" formControlName="couponMobile" placeholder="Mobile Number*" maxlength="10" required class="form-control mb-2 p-2">
          <textarea type="text" formControlName="couponIssue" placeholder="Describe Your Issue (Optional)" class="form-control mb-2 p-2"></textarea>
          <!-- <input type="text" name="couponName" placeholder="Full Name *" required>
          <input type="tel" name="couponMobile" placeholder="Mobile Number *" maxlength="10" required>
          <textarea name="couponIssue" placeholder="Describe Your Issue (Optional)"></textarea> -->
              <button type="button" class="submit-btn btn btn-primary w-100" (click)="applyCouponForm()">
            🚀 Confirm & Apply Coupon
          </button>
        <div class="modal-footer-features">
          <div class="feature-item">
            <span>🔒</span><span>Secure Booking</span>
          </div>
          <div class="feature-item">
            <span>💯</span><span>Money Back Guarantee</span>
          </div>
          <div class="feature-item">
            <span>⚡</span><span>Instant Confirmation</span>
          </div>
        </div>
      </form>

    </div>

  </div>

  <!-- Success Confirmation Modal -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
      <div class="modal-content text-center">
        <div class="modal-body">
          <p style="margin-bottom: 0;">{{ successMessage }}</p>
          <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
          <p class="lead mb-6">We will call you shortly</p>
          <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="bg-dark text-inverse">
  <div class="container py-10">
    <div class="row gy-6 gy-lg-0">
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <div  class="bottom-logo-txt">
            <img style="align-items: center;  display: flex; justify-content: center;  width: 24px;" class="mb-4 imp" src="../../../assets/img/mobile_autoverse_logo.svg" srcset="./assets/img/mobile_autoverse_logo.svg 2x" alt="" />
            <div class="bottom-logo-txt-main" >AUTOVERSE</div>
          </div>
          <p class="mb-4 p" style="font-size: 16px">© 2023 Autoverse.  <br class="d-none d-lg-block" />All rights reserved.</p>
          <!-- <nav class="nav social social-white">
            <a href="#"><i class="uil uil-twitter"></i></a>
            <a href="#"><i class="uil uil-facebook-f"></i></a>
            <a href="#"><i class="uil uil-dribbble"></i></a>
            <a href="#"><i class="uil uil-instagram"></i></a>
            <a href="#"><i class="uil uil-youtube"></i></a>
          </nav> -->
          <!-- /.social -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Get in Touch</h4>
          <address class="pe-xl-15 pe-xxl-17 address">{{ garageData?.address }}</address>
          <a href="mailto:#">{{ garageData.email }}</a><br />
          <div style="color: #aaa !important; font-weight: 500;">{{ garageData.mobileNumber }}</div>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-4 col-lg-3">
        <div class="widget">
          <!-- <h4 class="widget-title text-white mb-3 footre-learnmore">Learn More</h4>
          <ul class="list-unstyled  mb-0">
            <li><a href="#">Book Service Appointment</a></li>
            <li><a class="nav-link" (click)="scrollTo('About-us')">About Us</a></li>
            <li><a class="nav-link" (click)="scrollTo('our-services')">Our Services</a></li>
            <li><a class="nav-link" (click)="scrollTo('customer-review')">Customer Reviews</a></li>
            <li><a class="nav-link" (click)="scrollTo('contact-us')">Contact Us</a></li>
          </ul> -->
          <div class="go-back-btn" (click)="goToPeriodicpage()">Periodic Car Service </div>
            <div class="go-back-btn" (click)="goTodentingpage()">Denting & Painting</div>
            <div class="go-back-btn" (click)="goTocarpage()">Car Not Starting?</div>
            <div class="go-back-btn" (click)="goTobrakepage()">Brake Noise or Weak Brakes?</div>
            <div class="go-back-btn" (click)="goTonoisepage()">Engine Noise or Warning Light?</div>
            <div class="go-back-btn" (click)="goToAcpage()">AC Not Cooling Properly?</div>
            <!-- <div class="go-back-btn" (click)="goToSteeringpage()">Suspension or Steering Issues?</div> -->
            <div class="go-back-btn" (click)="goToTyrepage()">Tyres Worn Out or Vibrating?</div>
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
      <div class="col-md-12 col-lg-3">
        <div class="widget">
          <h4 class="widget-title text-white mb-3">Service With Care</h4>
          <p class="mb-5">A friendly garage that understands your car and your concerns.</p>
          <div class="newsletter-wrapper">
            <!-- Begin Mailchimp Signup Form -->
            <div id="mc_embed_signup2">
              <form action="https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&amp;id=b49ef47a9a" method="post" id="mc-embedded-subscribe-form2" name="mc-embedded-subscribe-form" class="validate dark-fields" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll2">
                  <div class="mc-field-group input-group form-floating">
                    <!-- <input type="email" value="" name="EMAIL" class="required email form-control" placeholder="Email Address" id="mce-EMAIL2">
                    <label for="mce-EMAIL2">Email Address</label>
                    <input type="submit" value="Join" name="subscribe" id="mc-embedded-subscribe2" class="btn btn-primary"> -->
                    <div class="button_div">
                      <button class="requestBtn-new" (click)="openRequestModal()">
                        Book an Appointment
                      </button>
                    </div>
                  </div>
                  <div id="mce-responses2" class="clear">
                    <div class="response" id="mce-error-response2" style="display:none"></div>
                    <div class="response" id="mce-success-response2" style="display:none"></div>
                  </div> <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_ddc180777a163e0f9f66ee014_4b1bcfa0bc" tabindex="-1" value=""></div>
                  <div class="clear"></div>
                </div>
              </form>
            </div>
            <!--End mc_embed_signup-->
          </div>
          <!-- /.newsletter-wrapper -->
        </div>
        <!-- /.widget -->
      </div>
      <!-- /column -->
    </div>
    <!--/.row -->
  </div>
  <!-- /.container -->
</footer>